/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import Header from "components/Header/Header.js";
import Header2 from "components/Header/Header2.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Footer from "components/Footer/Footer.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import SectionLatestOffers from "views/EcommercePage/Sections/SectionLatestOffers.js";
import SectionProducts from "views/EcommercePage/Sections/SectionProducts.js";
import SectionBlog from "views/EcommercePage/Sections/SectionBlog.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui icons
import Mail from "@material-ui/icons/Mail";

import ecommerceHeader from "assets/img/examples/ecommerce-header.jpg";
import face1 from "assets/img/faces/card-profile6-square.jpg";
import face2 from "assets/img/faces/christian.jpg";
import face3 from "assets/img/faces/card-profile4-square.jpg";
import face4 from "assets/img/faces/card-profile1-square.jpg";
import face5 from "assets/img/faces/marc.jpg";
import face6 from "assets/img/faces/kendall.jpg";
import face7 from "assets/img/faces/card-profile5-square.jpg";
import face8 from "assets/img/faces/card-profile2-square.jpg";

import styles from "assets/jss/material-kit-pro-react/views/ecommerceStyle.js";

const useStyles = makeStyles(styles);

export default function EcommercePage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  
    const hash = window.location.hash;
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 200); // wait for page to fully render
      }
    }
  }, []);
  
  const classes = useStyles();
  return (
    <div>
      <Header2 />

      <div className={classNames(classes.main, classes.mainRaised)}>
        <SectionLatestOffers />
        {/* <SectionProducts /> */}
      </div>
      <SectionBlog />
      <div
        className={classNames(classes.subscribeLine, classes.subscribeLineImage)}
        style={{ backgroundImage: `url(${ecommerceHeader})` }}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={6}
              md={6}
              className={classNames(classes.mlAuto, classes.mrAuto)}
            >
              <div className={classes.textCenter}>
                <h3 className={classes.title}>Bültenimize Katılın</h3>
                <p className={classes.description}>
                  Yeni koleksiyonlarımız, kampanyalarımız ve planlama ipuçları her hafta e-posta kutunuzda! 
                  Gereksiz e-posta göndermeyiz, söz veriyoruz.
                </p>
              </div>
              <Card raised className={classes.card}>
                <CardBody className={classes.cardBody}>
                  <form>
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6} lg={8}>
                        <CustomInput
                          id="emailPreFooter"
                          formControlProps={{
                            fullWidth: true,
                            className: classes.cardForm
                          }}
                          inputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Mail />
                              </InputAdornment>
                            ),
                            placeholder: "E-posta adresiniz..."
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6} lg={4}>
                        <Button
                          color="rose"
                          block
                          className={classes.subscribeButton}
                        >
                          Abone Ol
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>


      <Footer
        theme="dark"
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a href="/blog-posts" className={classes.block}>Blog</a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a href="/about-us" className={classes.block}>Hakkımızda</a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a href="/products" className={classes.block}>Mağaza</a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a href="/contact-us" className={classes.block}>İletişim</a>
                </ListItem>
              </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()}{" "} 
              <a href="/" className={classes.aClasses}>
                Kisetsu
              </a>{" "}
              tarafından sevgiyle tasarlandı.
            </div>
          </div>
        }
      >
        <GridContainer>
          <GridItem xs={12} sm={6}>
            <h5>Hakkımızda</h5>
            <p>
              Kisetsu, üretkenliği ve estetiği bir araya getiren özel tasarım ajandalar üretir.
              Hayatınızı planlarken ilham alacağınız ürünlerle yanınızdayız.
            </p>
          </GridItem>
          <GridItem xs={12} sm={6}>
            <h5>Sosyal Medya</h5>
            <div className={classes.socialFeed}>
              <div>
                <i className="fab fa-instagram" />
                <p>Yeni koleksiyonumuz yayında! #kisetsuajanda</p>
              </div>
            </div>
          </GridItem>
        </GridContainer>
      </Footer>

    </div>
  );
}
